// extracted by mini-css-extract-plugin
module.exports = {"tabs":"stocktabpanel_tabs__1MYR6"};